import Stack from '@mui/material/Stack'
import styled from '@mui/material/styles/styled'

export const ServiceListCardContent = styled(Stack, {
  name: 'ServiceListCardContent',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  fontFamily: 'Source Sans Pro',
  fontSize: '16px',
  margin: 0,
  padding: theme.spacing(0),
}))
